import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-google-charts-custom-tooltip',
  templateUrl: './google-charts-custom-tooltip.component.html',
  styleUrls: ['./google-charts-custom-tooltip.component.scss']
})
export class GoogleChartsCustomTooltipComponent {
  @Input() xValue : string;
  @Input() yValue : string;
  @Input() borderLeftColour : string = "#0000FF"; 
}
